import { cva } from "class-variance-authority";
import { Fund } from "creso-core/types";

export const RiskCell = ({ value }: { value: Fund["risk_level"] }) => {
  const variants = cva("rounded-sm font-medium px-2 py-1 text-xs", {
    variants: {
      variant: {
        "Low Risk": "text-tag-green-foreground bg-tag-green",
        "Low to Moderate Risk": "text-tag-lime-foreground bg-tag-lime",
        "Moderate Risk": "text-tag-yellow-foreground bg-tag-yellow",
        "Moderately High risk": "text-tag-yellow-foreground bg-tag-yellow",
        "High Risk": "text-tag-orange-foreground bg-tag-orange",
        "Very High Risk": "text-tag-red-foreground bg-tag-red",
      } as Record<string, string>,
    },
    defaultVariants: { variant: "Low Risk" },
  });

  return (
    <span className={variants({ variant: value })}>
      {value?.replace(" Risk", "")?.replace(" risk", "")}
    </span>
  );
};
